
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#D1E3F9"}}),_c('g',{attrs:{"clip-path":"url(#clip0_16378_57098)","fill":"#1664D8"}},[_c('path',{attrs:{"d":"M21.667 16.667h-8.334c-.919 0-1.666.747-1.666 1.666v8.334c0 .919.747 1.666 1.666 1.666h8.334c.919 0 1.666-.747 1.666-1.666v-8.334c0-.919-.747-1.666-1.666-1.666z"}}),_c('path',{attrs:{"d":"M26.667 11.667h-8.334a1.667 1.667 0 00-1.666 1.666V15h6.666A1.666 1.666 0 0125 16.667v6.666h1.667a1.667 1.667 0 001.666-1.666v-8.334a1.667 1.667 0 00-1.666-1.666z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_16378_57098"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(10 10)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    